/*
 * **Les deux délais du monde**, écrits une fois (chantier nettoyage-fiche, ticket 04). Une bulle
 * a un délai en jours ou en mois, jamais les deux : poser l'un efface l'autre (décision d'Igor du
 * 2026-10-07, chantier nettoyage-contrat, ticket 02). Le serveur l'écrit en base
 * (`effetsDuChangement`), l'app le montre tout de suite, avant la réponse (`useModifier`). Sans
 * dépendance : l'entrée « . » du paquet, l'app peut l'importer.
 */
/**
 * L'autre unité, effacée quand le changement pose un délai (0 compris : c'est un délai) : le
 * dernier posé gagne. Effacer un délai (`null`) ne touche pas à l'autre. Un changement qui dit
 * déjà l'autre (`{ delaiJours: 15, delaiMois: null }`) garde ce qu'il dit ; celui qui pose les
 * deux est refusé avant, par le serveur (`modificationNoeud`).
 */
export function autreDelaiEfface(demande) {
    if (demande.delaiJours != null && demande.delaiMois === undefined)
        return { delaiMois: null };
    if (demande.delaiMois != null && demande.delaiJours === undefined)
        return { delaiJours: null };
    return {};
}
